import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "parameters-view" };
const _hoisted_2 = { class: "parameters-header" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'Parameters',
    setup(__props) {
        // Parameters functionality will be implemented here
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.$t("dashboard.menu.parameters")), 1 /* TEXT */)
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "content-placeholder" }, [
                    _createElementVNode("p", null, "Parameters content will be implemented here.")
                ], -1 /* CACHED */))
            ]));
        };
    }
});
